import { TileLayer } from '@deck.gl/geo-layers';
import { PolygonLayer } from 'deck.gl';

export const geofenceLayer = (geofences: any) => {
  if (!geofences.display || !geofences.data.length) return null;

  // Color mapping per geofence type
  const TYPE_COLORS: { [key: string]: number[] } = {
    REEFER_STORAGE: [0, 255, 0, 150],
    DRY_STORAGE: [255, 165, 0, 150],
    CUSTOM: [255, 0, 0, 150],
    PHYTO: [255, 255, 0, 150],
    RAIL_TERMINAL: [128, 0, 128, 150],
    LOADING_QUAY: [0, 255, 255, 150],
  };

  return new TileLayer({
    id: 'geofence-tile-layer',
    minZoom: 10,
    maxZoom: 100,
    tileSize: 1024,

    getTileData: (tile: any) => {
      // Filter geofences within the tile's bounding box
      return Promise.resolve(
        geofences.data.filter((d: any) => {
          if (d.geojson && d.geojson.coordinates && d.geojson.coordinates[0]) {
            const firstCoord = d.geojson.coordinates[0][0];
            if (
              Array.isArray(firstCoord) &&
              firstCoord.length === 2 &&
              typeof firstCoord[0] === 'number' &&
              typeof firstCoord[1] === 'number'
            ) {
              const [longitude, latitude] = firstCoord;
              return (
                longitude >= tile.bbox.west &&
                longitude <= tile.bbox.east &&
                latitude >= tile.bbox.south &&
                latitude <= tile.bbox.north
              );
            }
          }
          return false;
        }),
      );
    },

    renderSubLayers: (props: any) => {
      const tileData = props.data;
      if (!tileData || tileData.length === 0) {
        return null;
      }

      // Filter by selected types
      const filteredData = tileData.filter((d: any) =>
        geofences.selectedTypes?.includes(d.type),
      );

      if (!filteredData.length) {
        return null;
      }

      return new PolygonLayer({
        id: `${props.id}-polygon-layer`,
        data: filteredData,
        pickable: true,
        stroked: true,
        filled: true,
        wireframe: true,
        lineWidthMinPixels: 1,
        getPolygon: (d: any) => d.geojson.coordinates[0],
        // Color depending on geofence type
        getFillColor: (d: any) =>
          (TYPE_COLORS[d.type] || [0, 200, 255, 150]) as [
            number,
            number,
            number,
            number,
          ],
        getLineColor: [0, 0, 0],
        getLineWidth: 1,
      });
    },
  });
};
